module.exports = __webpack_public_path__ + "files/bfaff6ab2205e4da7f3049a5befe88fd.png";